import React from 'react';
import ReactDOM from 'react-dom';

import PageTryNow from '../app/components/pages/PageTryNow.jsx';

const root = document.getElementById('try-now-modal');

if (root) {
  ReactDOM.render((
    <PageTryNow path="home" />
  ), root);
}
